export default __webpack_public_path__ + "static/media/ramen.de1bd169.png";